// MartianEndCard -- GLIM-led closing frame: approved lockup, positioning
// ("MARTIAN / AI Chief Growth Officer") and the locked tagline. Use it only
// where an end card is appropriate (final CTA, share/OG-style frames). The
// tagline is not repeated elsewhere and no other taglines are invented.

import { GLIM } from './GLIM';
import { MartianWordmark } from './MartianLogo';
import { BRAND_COPY } from './assets';
import './brand.css';

export function MartianEndCard({ showTagline = true, children, className = '', glimSize = 112, ...rest }) {
  return (
    <section
      className={`martian-endcard ${className}`.trim()}
      aria-label={`${BRAND_COPY.name} — ${BRAND_COPY.descriptor}`}
      data-testid="martian-endcard"
      {...rest}
    >
      <GLIM size={glimSize} tone="cream-on-ink" decorative />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
        <MartianWordmark size="lg" tone="dark" />
        <span className="martian-lockup__descriptor" style={{ fontSize: 14, color: 'rgba(236,228,214,0.78)' }}>
          {BRAND_COPY.descriptor}
        </span>
      </div>
      <span className="martian-endcard__rule" aria-hidden="true" />
      {showTagline && <p className="martian-endcard__tagline" style={{ margin: 0 }}>{BRAND_COPY.tagline}</p>}
      {children}
    </section>
  );
}

export default MartianEndCard;
